import store from '@/store'

// Order/price helpers shared by the analytics trackers (Meta Pixel, GTM/GA4). Both destinations
// want the same things: a plain numeric amount, an ISO-4217 currency code and per-unit line items.

// localization only exposes a symbol today; analytics destinations need an ISO-4217 code.
const CURRENCY_CODE_BY_SYMBOL = {
  $: 'USD',
  US$: 'USD',
  C$: 'CAD',
  CA$: 'CAD',
  A$: 'AUD',
  '€': 'EUR',
  '£': 'GBP',
  '₺': 'TRY',
  '₸': 'KZT',
  '₽': 'RUB',
  '₹': 'INR',
  '¥': 'JPY',
  '₩': 'KRW',
  '₪': 'ILS',
  '₦': 'NGN',
  '₱': 'PHP',
  R$: 'BRL',
  '﷼': 'SAR',
  'د.إ': 'AED',
}

export function getCurrencyCode() {
  const localization = store.state.storeConfig?.localization
  const explicitCode = localization?.currency_code || localization?.currency
  if (explicitCode) return String(explicitCode).toUpperCase()
  // Wallet payment requests carry a real ISO code when the backend provides one.
  const walletCode = store.state.orderData?.order?.payment_request?.details?.total?.amount?.currency
  if (walletCode) return String(walletCode).toUpperCase()
  return CURRENCY_CODE_BY_SYMBOL[localization?.currency_symbol] || 'USD'
}

// Analytics destinations drop events whose value isn't a plain number, so never pass a
// formatted price through.
export function centsToAmount(cents) {
  const amount = Number(cents)
  if (!Number.isFinite(amount)) return 0
  return Number((amount / 100).toFixed(2))
}

// Cart/order items price modifiers separately; the item's real price is its own extended_price
// plus every nested child item's.
export function itemTotalCents(item) {
  let total = Number(item?.extended_price) || 0
  const children = item?.child_items || []
  children.forEach((child) => {
    total += itemTotalCents(child)
  })
  return total
}

// Normalised line items: modifiers rolled into the price, which is per unit.
export function orderLineItems(items) {
  return (items || []).map((item) => {
    const quantity = Number(item.quantity ?? item.display_quantity ?? 1) || 1
    return {
      id: String(item.item_id),
      name: item.item_name,
      quantity: quantity,
      unitPrice: centsToAmount(itemTotalCents(item) / quantity),
    }
  })
}
